import { Button, ButtonSize, ButtonVariant } from "shared/components";

type SaveCancelButtonsProps = {
  onSave: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  saveText?: string;
  cancelText?: string;
  saveLoading?: boolean;
  saveDisabled?: boolean;
  size?: ButtonSize;
  saveVariant?: ButtonVariant;
  cancelVariant?: ButtonVariant;
  containerClassName?: string;
};

export const SaveCancelButtons = ({
  onSave,
  onCancel,
  saveText = "Save",
  cancelText = "Cancel",
  saveLoading,
  saveDisabled,
  size = ButtonSize.SM,
  saveVariant = ButtonVariant.PRIMARY,
  cancelVariant = ButtonVariant.BASE,
  containerClassName = "flex gap-2 pt-4"
}: SaveCancelButtonsProps) => {
  return (
    <div className={containerClassName}>
      <Button
        onClick={onSave}
        size={size}
        variant={saveVariant}
        loading={saveLoading}
        disabled={saveDisabled}
        className="w-[92px]"
      >
        {saveText}
      </Button>
      <Button
        onClick={onCancel}
        size={size}
        variant={cancelVariant}
        className="w-[92px]"
      >
        {cancelText}
      </Button>
    </div>
  );
};
